var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    section: true,
    'section-background-image': true,
    [`section${_vm.orderNo}`]: true
  }},[_c('a',{staticClass:"navigation-target",attrs:{"id":_vm.hash,"href":"javascript:void(0);"}}),_vm._v(" "),_c('div',{staticClass:"row background-image",style:(`background-image: url(${_vm.resourceUrl(_vm.data.image)})`)},[_c('div',{staticClass:"col col-12"},[_c('div',{staticClass:"content-header"},[_c('div',{staticClass:"gradient-background"}),_vm._v(" "),_c('AtomsCommonAtomTitle',{attrs:{"title":_vm.data.title,"subtitle":_vm.data.subtitle}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }